import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { attendanceMonth } from '../api/attendance';
import { kpiDetail, revenueMonthly } from '../api/kpi';
import { listTasks } from '../api/tasks';
import RevenueChart from '../components/RevenueChart';
import { useModal } from '../components/ModalProvider';
import { useToast } from '../components/Toast';
import FaceAttendanceModal from '../components/FaceAttendanceModal';
import { roleName } from '../utils/format';

// Số tiền gọn: 2,48 tỷ / 680 tr / 12 k.
function compact(n) {
  n = Number(n) || 0;
  if (n >= 1e9) return (n / 1e9).toFixed(2).replace('.', ',') + ' tỷ';
  if (n >= 1e6) return Math.round(n / 1e6) + ' tr';
  if (n >= 1e3) return Math.round(n / 1e3) + ' k';
  return String(n);
}
function greet() {
  const h = new Date().getHours();
  if (h < 11) return 'Chào buổi sáng';
  if (h < 13) return 'Chào buổi trưa';
  if (h < 18) return 'Chào buổi chiều';
  return 'Chào buổi tối';
}
const firstName = (name) => (name || '').trim().split(/\s+/).slice(-1)[0] || name;
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const TASK_CHIP = {
  late: { label: 'Trễ hạn', cls: 'late' },
  todo: { label: 'Cần làm', cls: 'todo' },
  doing: { label: 'Đang làm', cls: 'doing' },
  review: { label: 'Chờ duyệt', cls: 'review' },
  done: { label: 'Hoàn thành', cls: 'done' },
};

export default function MobileDashboard() {
  const { me } = useAuth();
  const { openModal, closeModal } = useModal();
  const toast = useToast();
  const canAttendance = me.role === 'NV' || me.role === 'TP';
  const [today, setToday] = useState(undefined); // undefined=đang tải, null=chưa chấm
  const [kpi, setKpi] = useState(null);
  const [monthly, setMonthly] = useState(null);
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const uid = me.id || me._id;
    const m = todayStr().slice(0, 7);
    if (canAttendance) {
      attendanceMonth(uid, m)
        .then((d) => setToday((d.days || []).find((x) => x.date === todayStr()) || null))
        .catch(() => setToday(null));
    }
    kpiDetail(uid).then((d) => setKpi(d.kpi)).catch(() => {});
    revenueMonthly().then(setMonthly).catch(() => {});
    listTasks().then((list) => setTasks(Array.isArray(list) ? list : (list.items || []))).catch(() => {});
  }, [me, canAttendance]);

  // Doanh thu tháng + % so tháng trước (theo phạm vi của mình: cá nhân/nhóm/công ty).
  const rev = (() => {
    if (!monthly?.company?.length) return null;
    const now = new Date();
    const idx = monthly.year === now.getFullYear() ? now.getMonth() : monthly.company.length - 1;
    const cur = Number(monthly.company[idx]) || 0;
    const prev = idx > 0 ? Number(monthly.company[idx - 1]) || 0 : 0;
    const delta = prev > 0 ? Math.round(((cur - prev) / prev) * 100) : null;
    return { cur, delta };
  })();

  const attStatus = today
    ? (today.status === 'work' ? { t: 'Đủ công', ok: true }
      : today.status === 'half' ? { t: 'Nửa công', ok: false }
      : today.phat > 0 ? { t: 'Có lỗi', ok: false }
      : { t: 'Đã chấm', ok: true })
    : { t: 'Chưa chấm', ok: false };

  // Việc cần làm: chưa hoàn thành, ưu tiên trễ hạn -> chờ duyệt -> đang làm.
  const myTasks = (tasks || [])
    .filter((t) => t.status !== 'done')
    .slice(0, 4);

  return (
    <div className="mbhome">
      <div className="mbhome-hero">
        <div className="mbhome-greet">{greet()}, {firstName(me.name)} <span aria-hidden>👋</span></div>
        <div className="mbhome-role">{roleName(me.displayRole || me.role)}{me.group ? ` · ${me.group.name}` : ''}</div>
      </div>

      {/* Hôm nay (chấm công) — chỉ NV/TP */}
      {canAttendance && (
        <div className="card mbhome-today">
          <div className="mbhome-today-head">
            <b>Hôm nay</b>
            <span className={'mbhome-att-status' + (attStatus.ok ? ' ok' : '')}>
              <i className={`ti ti-${attStatus.ok ? 'circle-check' : 'clock'}`} /> {attStatus.t}
            </span>
          </div>
          <div className="mbhome-today-times">
            <div className="mbhome-time">
              <div className="mbhome-time-lb">Giờ vào</div>
              <div className="mbhome-time-val">{today?.checkIn || '--:--'}</div>
            </div>
            <div className="mbhome-time-div" />
            <div className="mbhome-time">
              <div className="mbhome-time-lb">Giờ ra</div>
              {/* MỚI CHẤM 1 LẦN (buổi sáng) -> CHƯA có giờ ra. Backend lưu checkOut = mốc MUỘN NHẤT
                  nên lần chấm đầu checkOut trùng checkIn — phải xem checkCount mới đúng nghĩa. */}
              <div className="mbhome-time-val">{(today?.checkCount || 0) >= 2 ? today.checkOut : '--:--'}</div>
            </div>
          </div>
          <button className="mbhome-cham" onClick={() => openModal(<FaceAttendanceModal onClose={closeModal} toast={toast} />)}>
            <i className="ti ti-face-id" /> Chấm công khuôn mặt
          </button>
        </div>
      )}

      {/* 2 thẻ: Doanh thu tháng + KPI */}
      <div className="mbhome-stats">
        <div className="card mbhome-stat">
          <div className="mbhome-stat-lb">Doanh thu tháng</div>
          <div className="mbhome-stat-val">{rev ? compact(rev.cur) : '—'}</div>
          {rev?.delta != null && (
            <div className={'mbhome-stat-delta' + (rev.delta >= 0 ? ' up' : ' down')}>
              <i className={`ti ti-arrow-${rev.delta >= 0 ? 'up' : 'down'}-right`} /> {Math.abs(rev.delta)}% so tháng trước
            </div>
          )}
        </div>
        <div className="card mbhome-stat">
          <div className="mbhome-stat-lb">KPI</div>
          <div className="mbhome-stat-val">{kpi ? `${kpi.onTimeRate}%` : '—'}</div>
          {kpi && (
            <div className="mbhome-stat-delta muted">
              {kpi.totalTasks} việc{kpi.lateCount > 0 ? ` · ${kpi.lateCount} trễ` : ''}
            </div>
          )}
        </div>
      </div>

      {/* Biểu đồ doanh thu */}
      <div className="card mbhome-chart">
        <b>Doanh thu {monthly?.year ? `· ${monthly.year}` : 'theo tháng'}</b>
        <div className="mbhome-chart-wrap">
          {monthly?.company?.some((v) => v) ? (
            <RevenueChart months={monthly.months} values={monthly.company} color="#4b47e6" />
          ) : (
            <div className="empty">Chưa có dữ liệu doanh thu.</div>
          )}
        </div>
      </div>

      {/* Việc cần làm */}
      <div className="card mbhome-tasks">
        <div className="mbhome-tasks-head"><b>Việc cần làm</b></div>
        {myTasks.length ? myTasks.map((t) => {
          const chip = TASK_CHIP[t.status] || TASK_CHIP.todo;
          const cust = t.items?.[0]?.custName || t.customerName || '';
          return (
            <div className="mbhome-task" key={t._id}>
              <div className="mbhome-task-main">
                <div className="mbhome-task-title">{t.title}</div>
                {cust && <div className="mbhome-task-sub">{cust}</div>}
              </div>
              <span className={`chip ${chip.cls}`}>{chip.label}</span>
            </div>
          );
        }) : <div className="empty">Không có việc nào đang chờ.</div>}
      </div>
    </div>
  );
}
